export default "__VITE_ASSET__8c782935__"